import { Box } from '../../../common/ui/Box';
import { translate } from '../../helpers/translate.helper';
import { IconFilesOff } from '../../icons/cdl/FilesOff';
import { TableEmptyState } from '../../TableEmptyState/TableEmptyState';
import { AttachmentListFile } from '../types/AttachmentListFile';

import { AttachmentRow } from './AttachmentRow';

interface AttachmentListProps {
    files: AttachmentListFile[];
    companyId?: string;
    counterCompanyName?: string;
    hasWriteRights: boolean;
}

export const AttachmentList = ({ files, companyId, counterCompanyName, hasWriteRights }: AttachmentListProps) => {
    const sortedFiles = Array.from(files).sort((a, b) => {
        if (new Date(a.dateCreated) > new Date(b.dateCreated)) {
            return -1;
        }
        if (new Date(a.dateCreated) < new Date(b.dateCreated)) {
            return 1;
        }
        return 0;
    });

    if (!sortedFiles.length && hasWriteRights) {
        return null;
    }

    if (!sortedFiles.length && !hasWriteRights) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" padding={64}>
                <TableEmptyState text={translate('attachments.noFiles')} Icon={IconFilesOff} />
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" padding={32} alignItems="stretch">
            {sortedFiles.map((file) => {
                return (
                    <AttachmentRow
                        key={file.id}
                        file={file}
                        companyId={companyId}
                        counterCompanyName={counterCompanyName}
                    />
                );
            })}
        </Box>
    );
};
